import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

const Reviews = () => {
  const reviews = [
    {
      name: "Aqib Khan",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        " My experience at Meliora Dental was excellent. Staff were very helpful, Dr Kunal did an excellent job with myalignar treatment. I was extremely happy with the results. I recommend anyone who is thinking about getting aligners. ",
      stars: 5,
    },
    {
      name: "Ashi K",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "10/10 Amazing experience - highly recommend. Had my consultation with Dr Kunal in regard to having a straighter smile. Dr Kunal talked me through the process and made me feel super comfortable in the consultation. I am now on my alignar journey and can already see amazing results.",
      stars: 5,
    },
    {
      name: "Lucas Fantini",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "Incredible results with my alignars.. incredible attention from Dr Kunal. Strongly recommend!!!",
      stars: 5,
    },
    {
      name: "Michele",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "Thank you very much. It really brings it home what a transformation you have achieved! I was a bit reticent about getting the lot done at first but I'm extremely glad I went for it, so thank you for suggesting it in the first place as I had no idea that sort of thing could be done. I'm very happy indeed with the result!",
      stars: 5,
    },
    {
      name: "Lauren",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "Couldn't recommend Alignars more highly. Their expertise in the teeth transition process and the great staff made my teeth journey an exciting process.",
      stars: 5,
    },
    {
      name: "Ash",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "10/10 Amazing experience highly recommend. Had my consultation with Dr Kunal in regards to having a straighter smile. Dr Kunal talked me through the process and made me feel super comfortable in the consultation. I am now on my aligner journey and can already see amazing results. Super excited to see how my teeth look at the end.",
      stars: 5,
    },
    {
      name: "Sam",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "I can't thank Kunal and Kayleigh enough, I'm absolutely buzzing with my new smile! Wouldn't hesitate to recommend him to anyone, he's a top guy and amazing at what he does.",
      stars: 5,
    },
    {
      name: "Shabana",
      image: "https://cdn-icons-png.flaticon.com/512/219/219986.png",
      review:
        "We had a fantastic experience with Dr Kunal and his team. From the very beginning, he took the time to thoroughly explain the aligner process and how they work, making us feel confident in our decision. The aligners were comfortable, and we noticed a significant improvement in my son’s teeth over time. The results have been truly amazing.",
      stars: 5,
    },
  ];

  const renderStars = (stars) => {
    let starArray = [];
    for (let i = 0; i < stars; i++) {
      starArray.push(
        <span key={i} style={{ color: "#FFB525", fontSize: "1.2rem" }}>
          &#9733;
        </span>
      );
    }
    return starArray;
  };

  return (
    <div className="container my-5">
      <div className="row justify-content-center text-center mt-5 mb-4">
        <h2 className="fs-44 fw-400">
          What Our <span className="text-yellow">Patients Say</span>
        </h2>
      </div>

      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
        }}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="card my-4 border-0 rounded-4 testimonial-card">
              <div className="card-body d-flex flex-column">
                <div className="d-flex align-items-center">
                  <h5
                    className="card-title text-center"
                    style={{ marginBottom: "5px" }}
                  >
                    {review.name}
                  </h5>
                </div>
                <div>
                  <p className="card-text my-2">{review.review}</p>
                  <div
                    className="stars"
                    style={{ fontSize: "1.2rem", marginTop: 0 }}
                  >
                    {renderStars(review.stars)}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx>{`
        .swiper-pagination {
          position: relative;
          top: 10px; /* Adjust the space between the cards and pagination */
          margin-top: 20px; /* Additional margin for more spacing */
        }

        .swiper-pagination-bullet {
          background-color: black; /* Blue color for pagination bullets */
          width: 12px;
          height: 12px;
          margin: 0 5px; /* Space between pagination bullets */
        }

        .swiper-pagination-bullet-active {
          background-color: #ffb525; /* Yellow color for active pagination dot */
        }
      `}</style>
    </div>
  );
};

export default Reviews;
